/**
 * Cliente del CRUD de `module_config` (Fase 32). Spec en
 * `docs/start-plan/32-module-config-from-backoffice.md`.
 */
import { get, patchJsonAdmin } from './_core.js';

export type ConfigSlug = 'videos' | 'coach' | 'languages' | 'scout' | 'spar';

export interface ModuleConfigResponse {
  slug: string;
  /** Config efectiva: defaults + overrides DB, ya parseada server-side. */
  config: Record<string, unknown>;
  /** Body crudo en DB. `null` si nunca se tocó. */
  storedConfig: Record<string, unknown> | null;
  updatedAt: string | null;
  updatedBy: string | null;
}

export interface ModuleConfigAuditEntry {
  id: string;
  changedAt: string;
  changedByUserId: string | null;
  beforeConfig: Record<string, unknown> | null;
  afterConfig: Record<string, unknown>;
}

export async function fetchModuleConfig(slug: ConfigSlug): Promise<ModuleConfigResponse> {
  const res = await get<ModuleConfigResponse>(`/admin/modules/${slug}/config`);
  return res.data;
}

export async function patchModuleConfig(
  slug: ConfigSlug,
  config: Record<string, unknown>,
): Promise<ModuleConfigResponse> {
  return patchJsonAdmin<ModuleConfigResponse>(`/admin/modules/${slug}/config`, config);
}

export async function fetchModuleConfigAudit(
  slug: ConfigSlug,
): Promise<{ slug: string; entries: ModuleConfigAuditEntry[] }> {
  const res = await get<{ slug: string; entries: ModuleConfigAuditEntry[] }>(
    `/admin/modules/${slug}/config/audit`,
  );
  return res.data;
}
